import { TableRow, withStyles, TableCell, Table } from '@material-ui/core';
import { colours, Title } from '@cambridgeassessment/cambridge-ui';
import styled from 'styled-components';

export const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

export const DetailsTableCell = withStyles({
  root: {
    fontFamily: 'SourceSansPro',
    paddingLeft: '0px',
    fontSize: '16px',
    border: colours.white,
    '&.MuiTableCell-head': {
      fontWeight: 'bold',
    },
  },
})(TableCell);

export const StyledTable = withStyles({
  root: {
    maxWidth: '1254px',
    borderBottom: 'solid #fafafa',
  },
})(Table);

export const StyledTitle = styled(Title)`
  font-size: 26px;
`;
